import { Badge, Spacer, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const UserTitle = _ref => {
  let {
    login,
    businessAccountName,
    isBusiness,
    isBody,
    isLoginForced,
    isBottomLoginHidden,
    isBadgeHidden,
    truncate
  } = _ref;
  const businessDisplayName = isBusiness && !isLoginForced && businessAccountName;
  const title = businessDisplayName || login;
  const translate = useTranslate('business');

  function renderBusinessAccountBadge() {
    if (!businessDisplayName || isBadgeHidden) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Regular
      }), /*#__PURE__*/_jsx(Badge, {
        content: translate('title'),
        testId: "profile-pro-badge"
      })]
    });
  }

  function renderBottomLogin() {
    if (!businessDisplayName || isBottomLoginHidden || isLoginForced) return null;
    return /*#__PURE__*/_jsx(Text, {
      width: Text.Width.Parent,
      text: "@".concat(login),
      type: Text.Type.Subtitle,
      testId: "profile-business-name"
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "u-flexbox u-align-items-center",
      children: [/*#__PURE__*/_jsx(Text, {
        text: title,
        type: isBody ? Text.Type.Body : Text.Type.Heading,
        theme: "amplified",
        truncate: truncate,
        bold: true,
        testId: "profile-username"
      }), renderBusinessAccountBadge()]
    }), renderBottomLogin()]
  });
};

export default UserTitle;